import React from 'react';
import { Grid } from 'semantic-ui-react';
import CohortName from '../containers/CohortName';
import CohortDescription from '../containers/CohortDescription';

const CohortInfoGridRows = ({
  code,
  category,
}) => (
  <>
    <Grid.Row>
      <Grid.Column>
        <CohortName code={code} category={category} />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <CohortDescription code={code} category={category} />
      </Grid.Column>
    </Grid.Row>
  </>
);

export default CohortInfoGridRows;
